import { Card, Chip, Text, Title } from '@nimbus-ds/components';
import { Stack } from 'commons/components';

function Skeleton(): JSX.Element {
  return (
    <Card>
      <Card.Header>
        <Title.Skeleton as="h4" width="20%" />
      </Card.Header>
      <Card.Body>
        <Stack column align="stretch">
          <Stack spacing="base">
            <Chip.Skeleton width="10%" />
            <Chip.Skeleton width="10%" />
          </Stack>
          <Stack.Item>
            <Text.Skeleton width="50%" />
          </Stack.Item>
        </Stack>
      </Card.Body>
    </Card>
  );
}

export default Skeleton;
